import { useCallback, useEffect, useState } from "react";
import request from "superagent";
import { BACKEND_URL } from "../config/config";
import Survey from "../types/Survey";
import useSessionToken from "./useSessionToken";

function useApiSurveySpecification(
  uuid?: string,
  slug?: string,
  useAuth = false
) {
  const sessionToken = useSessionToken();

  const [survey, setSurvey] = useState<Survey>();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error>();

  const [reloadKey, setReloadKey] = useState(0);

  useEffect(() => {
    if (!sessionToken && useAuth) {
      setError(undefined);
      setLoading(false);
      setSurvey(undefined);
      return;
    }

    setError(undefined);
    setLoading(true);

    let url = BACKEND_URL + `api/survey/v1/surveys/${uuid}/specification`;
    if (!uuid) {
      url = BACKEND_URL + `api/survey/v1/surveys/slug/${slug}/specification`;
    }

    const req = request.get(url);

    if (useAuth) {
      req.set("Authorization", `Bearer ${sessionToken}`);
    }

    req
      .then((res) => {
        setSurvey(res.body);
        setLoading(false);
      })
      .catch((err) => {
        if (err.code === "ABORTED") return;
        console.log(err);
        setSurvey(undefined);
        setError(err);
        setLoading(false);
      });

    return () => req.abort();
  }, [uuid, sessionToken, useAuth, reloadKey, slug]);

  const reload = useCallback(() => setReloadKey((key) => key + 1), []);

  return {
    survey,
    loading,
    error,
    reload,
  };
}

export default useApiSurveySpecification;
